export const getLocalSortModel = (table: string) => {
  if (localStorage.getItem('localSortModel'))
    return (
      JSON.parse(localStorage.getItem('localSortModel') as string)[table] || []
    );
  return [];
};
